// extracted by mini-css-extract-plugin
export var cardSelected = "_g7-2";
export var image = "_g7-1";
export var table = "_g7-0";